// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchTitle } from '../../../../components/shared/Titles';
import messages from './messages';
import styles from './styles';

type Props = {
  sources: Array<Source>,
  currentSourceIndex: number,
  isSticky: boolean,
  loaderRef: React.ElementRef<*>,
};

export default function SourceLoader({
  sources,
  currentSourceIndex,
  isSticky,
  loaderRef,
}: Props): React.Node {
  return (
    <div ref={loaderRef} className={`sources-loader${isSticky ? ' sticky' : ''}`}>
      <SearchTitle />
      <p>
        <FormattedMessage {...messages.title} />
      </p>

      <div className="image-wrapper">
        {sources.map((source, i) => (
          <img
            className={`${i === currentSourceIndex ? 'active' : ''}`}
            key={source.name}
            src={source.image}
            alt={source.name}
          />
        ))}
      </div>

      <svg viewBox="0 0 355 14">
        <rect fill="#DDDFE2" x="1" y="0" width="355" height="14" />
        <rect
          className="progress-bar-animate"
          id="small"
          fill="#3181F7"
          x="-110%"
          y="0"
          width="375"
          height="14"
        />
      </svg>
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Sources/loader/components/SourceLoader/index.js